import React from "react";
import { TESTIMONIALS } from "../lib/brand";
import { Star, Quote } from "lucide-react";

export default function Testimonials() {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative bg-white py-16 sm:py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-[color:var(--dbe-cream)]/50 to-transparent pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6">
        <div className="flex items-end justify-between flex-wrap gap-5 sm:gap-6 mb-10 sm:mb-14">
          <div>
            <p className="text-[color:var(--dbe-red)] text-xs tracking-[0.35em] uppercase font-bold">Reviews</p>
            <h2 className="mt-3 sm:mt-4 text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.02] font-bebas text-neutral-900">
              65 years of<br /><span className="text-[color:var(--dbe-red)]">happy neighbors.</span>
            </h2>
          </div>
          <div className="flex items-center gap-2 text-sm sm:text-lg">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 sm:w-5 sm:h-5 fill-[color:var(--dbe-red)] text-[color:var(--dbe-red)]" />
              ))}
            </div>
            <span className="ml-2 text-neutral-700">Trusted by thousands across South Florida</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="relative bg-white border border-neutral-200 rounded-2xl p-6 sm:p-7 hover:border-[color:var(--dbe-red)]/40 hover:-translate-y-1 transition-all duration-300 shadow-[0_20px_50px_-30px_rgba(15,15,25,0.15)]"
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-[color:var(--dbe-red)]/10" />
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-[color:var(--dbe-red)] text-[color:var(--dbe-red)]" />
                ))}
              </div>
              <blockquote className="text-neutral-800 leading-relaxed">"{t.quote}"</blockquote>
              <figcaption className="mt-5 pt-5 border-t border-neutral-200">
                <div className="font-bold text-neutral-900">{t.name}</div>
                <div className="text-neutral-500 text-sm">{t.location}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
